(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/app/app.html":
/*!*******************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/app/app.html ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"main-container\">\n\t<header class=\"header\">\n\t</header>\n\t<content-container class=\"content-container\">\n\t</content-container>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/auth/auth.html":
/*!*********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/auth/auth.html ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n\t<form [formGroup]=\"loginForm\" class=\"form-signin card-1\" (ngSubmit)=\"validateUser()\">\n\t\t<h2 class=\"form-signin-heading\">\n\t\t\tPlease sign in\n\t\t</h2>\n\n\t\t<p *ngIf=\"formErrors\" class=\"error\">\n\t\t\t* All fields are required\n\t\t</p>\n\t\t<p *ngIf=\"loginFailed && !formErrors\" class=\"error\">\n\t\t\t* Username/password combination is invalid\n\t\t</p>\n\n\t\t<label for=\"username\" class=\"sr-only\">\n\t\t\tUsername\n\t\t</label>\n\t\t<input type=\"username\" formControlName=\"username\" id=\"username\" class=\"form-control\" required autofocus>\n\t\t<label for=\"password\" class=\"sr-only\">\n\t\t\tPassword\n\t\t</label>\n\t\t<input type=\"password\" formControlName=\"password\" id=\"password\" class=\"form-control\" required>\n\t\t<button mat-raised-button class=\"submit-button\" type=\"submit\">Sign in</button>\n\t</form>\n</div>\n\n<div *ngIf=\"showProgressBar\" class=\"progress-bar-backing\">\n\t<div class=\"progress-bar-placement\">\n\t\t<mat-progress-bar\n\t\t\tmode=\"indeterminate\">\n\t\t</mat-progress-bar>\n\t</div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/content-container/content-container.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/content-container/content-container.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/cutlist-browser/cutlist-browser.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/cutlist-browser/cutlist-browser.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"browser-wrapper\">\n\t<h2 mat-dialog-title class=\"browser-title\">{{job.project_name}}</h2>\n\t<mat-dialog-content class=\"browser-content\">\n\t\t<img src={{image_url}}>\n\t</mat-dialog-content>\n\t<mat-dialog-actions class=\"browser-actions\">\n\t\t<button mat-button mat-dialog-close>Close</button>\n\t</mat-dialog-actions>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/header/header.html":
/*!*************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/header/header.html ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"header noselect\">\n\t<ul class=\"header-bar\">\n\t\t<li>\n\t\t\t<div\n\t\t\t\tstyle=\"\n\t\t\t\t\tbackground-image: url('/assets/cw_wordmark_white.min.svg');\n\t\t\t\t\tbackground-size: contain;\n\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\twidth: 3in;\n\t\t\t\t\theight: 0.50in;\n\t\t\t\t\"\n\t\t\t></div>\n\t\t\t<div *ngIf=\"showStagingIndicator()\" class=\"red staging-banner\">\n\t\t\t\tSTAGING\n\t\t\t</div>\n\t\t</li>\n\t\t<ng-container *ngIf=\"departments?.length\">\n\t\t\t<li>\n\t\t\t\t<mat-form-field>\n\t\t\t\t\t<mat-label>Type</mat-label>\n\t\t\t\t\t<mat-select\n\t\t\t\t\t\t[(value)]=\"filterViewType\"\n\t\t\t\t\t\t(selectionChange)=\"setViewType()\">\n\t\t\t\t\t\t<mat-option *ngFor=\"let t of filterViewTypes\" [value]=\"t\">\n\t\t\t\t\t\t\t{{t}}\n\t\t\t\t\t\t</mat-option>\n\t\t\t\t\t</mat-select>\n\t\t\t\t</mat-form-field>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<mat-form-field>\n\t\t\t\t\t<mat-label>DEPARTMENT</mat-label>\n\t\t\t\t\t<mat-select\n\t\t\t\t\t\t[(value)]=\"department\"\n\t\t\t\t\t\t(selectionChange)=\"setDepartment()\">\n\t\t\t\t\t\t<mat-option *ngFor=\"let dep of departments\" [value]=\"dep\">\n\t\t\t\t\t\t\t{{dep.name.toUpperCase()}}\n\t\t\t\t\t\t</mat-option>\n\t\t\t\t\t</mat-select>\n\t\t\t\t</mat-form-field>\n\t\t\t</li>\n\t\t\t<li (click)=\"logout()\">\n\t\t\t\tLogout\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<mat-spinner *ngIf=\"refreshing\" color=\"accent\" [diameter]=\"30\"></mat-spinner>\n\t\t\t\t<i *ngIf=\"!refreshing\" class=\"material-icons refresh-icon\" (click)=\"refresh()\">refresh</i>\n\t\t\t</li>\n\t\t</ng-container>\n\t</ul>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/jobs-list/jobs-list.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/jobs-list/jobs-list.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"loading\" class=\"loading\">\n\t<p>Loading</p>\n</div>\n\n<button *ngIf=\"allowDebug\" mat-raised-button color=\"primary\" (click)=\"debug()\">Debug</button>\n\n<div *ngIf=\"!loading\" class=\"container\">\n\t<table mat-table [dataSource]=\"dataSource\" *ngIf=\"department\">\n\t\t<ng-container matColumnDef=\"priority\" sticky>\n\t\t\t<th mat-header-cell *matHeaderCellDef></th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<div class=\"priority-level\" [ngClass]='\"priority-\" + job.priority'></div>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"part#\" [sticky]=\"true\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>#</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.part_no}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"project-name\" [sticky]=\"true\">\n\t\t\t<th mat-header-cell\n\t\t\t\t*matHeaderCellDef\n\t\t\t\tclass=\"forced-width-column force-text-align-center\">\n\t\t\t\tPROJECT NAME\n\t\t\t</th>\n\t\t\t<td mat-cell\n\t\t\t\t*matCellDef=\"let job\"\n\t\t\t\tclass=\"forced-width-column force-text-align-left\"\n\t\t\t\tstyle=\"word-wrap: normal;\">\n\t\t\t\t{{job.project_name}}\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"description\" [sticky]=\"true\">\n\t\t\t<th mat-header-cell\n\t\t\t\t*matHeaderCellDef\n\t\t\t\tclass=\"forced-width-columnforce-text-align-center\">\n\t\t\t\tDESCRIPTION\n\t\t\t</th>\n\t\t\t<td mat-cell\n\t\t\t\t*matCellDef=\"let job\"\n\t\t\t\tclass=\"forced-width-column force-text-align-left\">\n\t\t\t\t[{{job.job_id}}] {{job.name}} {{job.description}}\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"ship-date\" [sticky]=\"true\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SHIP DATE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.est_delivery_date | date: 'MM-dd-yyyy'}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"ups-tracking-number\" [sticky]=\"true\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>UPS TRACKING NUMBER</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<input type=\"text\"\n\t\t\t\t\t[(ngModel)]=\"job.ups_tracking_number\"\n\t\t\t\t\t(change)=\"updateJob(job, $event)\">\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<!--\n\t\t<ng-container matColumnDef=\"cutlist\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>VIEW CUTLIST</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<button *ngIf=\"job.attachments.length > 0\" mat-button (click)=\"openCutlistBrowser(job)\">\n\t\t\t\t\tview\n\t\t\t\t</button>\n\t\t\t</td>\n\t\t</ng-container>\n\t\t-->\n\n\t\t<ng-container matColumnDef=\"price\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>BILLABLE $ SANS FREIGHT</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.billable_cost | currency: '$'}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"unit-count\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>UNIT COUNT</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.unit_count}}</td>\n\t\t</ng-container>\n\n\t\t<!--\n\t\t<ng-container matColumnDef=\"ENGINEERING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>ENGINEERING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'engineering'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'engineering').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\t\t-->\n\n\t\t<ng-container matColumnDef=\"PURCHASING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>PURCHASING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'purchasing'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'purchasing').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"SAW/CNC\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SAW/CNC</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'saw_cnc'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'saw_cnc').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"EDGE BANDING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>EDGE BANDING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'edge_banding'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'edge_banding').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"DRAWERS\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>DRAWERS</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'drawers'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'drawers').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"DOORS\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>DOORS</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'doors'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'doors').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"SPECIALTY\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SPECIALTY</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'specialty'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'specialty').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"METAL\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>METAL</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'metal'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'metal').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"ASSEMBLY\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>ASSEMBLY</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'assembly'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'assembly').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"STAGING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>STAGING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'staging'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'staging').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"FINISH\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>FINISH</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'finish'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'finish').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"HANGING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>HANGING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'hanging'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'hanging').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"SHIPPING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SHIPPING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'shipping'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'shipping').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"INSTALL\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>INSTALL</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'install'))\"\n\t\t\t\t\t[checked]=\"getWorkflow(job, 'install').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"BILLING\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>BILLING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">\n\t\t\t\t<mat-checkbox\n\t\t\t\t\t(change)=\"toggleWorkflow(getWorkflow(job, 'billing'))\"\n\t\t\t\t\t[checked]= \"getWorkflow(job, 'billing').complete != null\">\n\t\t\t\t</mat-checkbox>\n\t\t\t</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"designer\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>DESIGNER</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.designer}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"customer-service\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>CUSTOMER SERVICE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.customer_service_rep}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"engineer\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>ENGINEERING</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.engineer}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"confirmed-date\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>CONFIRMED DATE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.confirmed_date | date: 'MM-dd-yyyy'}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"engineered-date\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>ENGINEERING DATE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.engineered_date | date: 'MM-dd-yyyy'}}</td>\n\t\t</ng-container>\n\n\t\t<!--\n\t\t<ng-container matColumnDef=\"actual-date-shipped\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>ACTUAL DATE SHIPPED</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.actual_date_shipped | date: 'MM-dd-yyyy'}}</td>\n\t\t</ng-container>\n\t\t-->\n\n\t\t<ng-container matColumnDef=\"exterior-material\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>EXTERIOR MATERIAL</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.species_cut}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"texture\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>TEXTURE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.texture}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"finish\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>FINISH</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.finish}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"finish-options\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>FINISH OPTIONS</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.finish_options}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"sheen\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SHEEN</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.sheen}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"door-frame\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>DOOR FRAME/INNER EDGE - PANEL PROFILE - OUTER EDGE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.door}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"shallow-drawer\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>SHALLOW DRAWER FRAME/INNER EDGE - PANEL PROFILE - OUTER EDGE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.shallow_drawer}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"drawer-box\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>DRAWER BOX TYPE - MATERIAL - GUIDE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.drawer_box}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"cabinet-interior\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>CABINET INTERIOR</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.interior}}</td>\n\t\t</ng-container>\n\n\t\t<ng-container matColumnDef=\"cabinet-type\">\n\t\t\t<th mat-header-cell *matHeaderCellDef>CABINET TYPE</th>\n\t\t\t<td mat-cell *matCellDef=\"let job\">{{job.cabinet_type}}</td>\n\t\t</ng-container>\n\n\t\t<tr mat-header-row *matHeaderRowDef=\"displayedColumns, sticky: true\"></tr>\n\t\t<tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n\t</table>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/page-not-found/page-not-found.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/page-not-found/page-not-found.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"flex-center-both\">\n\t\t<mat-card class=\"container text-align-center\">\n\t\t\t<h2>PAGE NOT FOUND</h2>\n\t\t\t<hr>\n\t\t\t<p class=\"bold\">\"{{getUrl()}}\"</p>\n\t\t\t<p>Is not known, please check that you have the correct URL and try again.</p>\n\t\t\t<a routerLink=\"/\" mat-raised-button color=\"primary\" class=\"medium-red-mat-raised-button\">Home</a>\n\t\t</mat-card>\n\t</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/warning-dialog/warning-dialog.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/warning-dialog/warning-dialog.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h1 class=\"text-align-center\">{{title}}</h1>\n<p *ngIf=\"message\" class=\"text-align-center\">{{message}}</p>\n<div class=\"text-align-right\">\n\t<button\n\t\tmat-raised-button\n\t\tcolor=\"primary\"\n\t\t[mat-dialog-close]=\"null\">\n\t\t{{buttonText}}\n\t</button>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _components_jobs_list_jobs_list_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/jobs-list/jobs-list.component */ "./src/app/components/jobs-list/jobs-list.component.ts");
/* harmony import */ var _components_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/page-not-found/page-not-found.component */ "./src/app/components/page-not-found/page-not-found.component.ts");
/* harmony import */ var _components_auth_auth_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/auth/auth.component */ "./src/app/components/auth/auth.component.ts");





// other

// import {AuthGuard}			from './AuthGuard';
const routes = [
    {
        component: _components_auth_auth_component__WEBPACK_IMPORTED_MODULE_5__["AuthComponent"],
        path: '',
    },
    {
        // canActivate: [AuthGuard],
        component: _components_jobs_list_jobs_list_component__WEBPACK_IMPORTED_MODULE_3__["JobsListComponent"],
        path: 'workflows',
    },
    //{
    //	// canActivate: [AuthGuard],
    //	component: JobsListComponent,
    //	path: 'inactive',
    //},
    // redirect all other routes
    {
        component: _components_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_4__["PageNotFoundComponent"],
        path: '**',
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
        // providers: [
        // 	JobService,
        // ],
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _components_auth_auth_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/auth/auth.component */ "./src/app/components/auth/auth.component.ts");
/* harmony import */ var _components_content_container_content_container_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/content-container/content-container.component */ "./src/app/components/content-container/content-container.component.ts");
/* harmony import */ var _components_cutlist_browser_cutlist_browser_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/cutlist-browser/cutlist-browser.component */ "./src/app/components/cutlist-browser/cutlist-browser.component.ts");
/* harmony import */ var _components_header_header_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/header/header.component */ "./src/app/components/header/header.component.ts");
/* harmony import */ var _components_jobs_list_jobs_list_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/jobs-list/jobs-list.component */ "./src/app/components/jobs-list/jobs-list.component.ts");
/* harmony import */ var _components_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/page-not-found/page-not-found.component */ "./src/app/components/page-not-found/page-not-found.component.ts");
/* harmony import */ var _material_module__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./material.module */ "./src/app/material.module.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _components_app_app_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/app/app.component */ "./src/app/components/app/app.component.ts");
/* harmony import */ var _angular_http__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/http */ "./node_modules/@angular/http/fesm2015/http.js");
/* harmony import */ var _services_department_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./services/department.service */ "./src/app/services/department.service.ts");
/* harmony import */ var _services_factory_job_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./services/factory_job.service */ "./src/app/services/factory_job.service.ts");
/* harmony import */ var _services_localstorage_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./services/localstorage.service */ "./src/app/services/localstorage.service.ts");
/* harmony import */ var _services_user_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./services/user.service */ "./src/app/services/user.service.ts");
/* harmony import */ var _session_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./session.service */ "./src/app/session.service.ts");
/* harmony import */ var _components_warning_dialog_warning_dialog_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/warning-dialog/warning-dialog.component */ "./src/app/components/warning-dialog/warning-dialog.component.ts");





















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        bootstrap: [_components_app_app_component__WEBPACK_IMPORTED_MODULE_13__["AppComponent"]],
        declarations: [
            _components_app_app_component__WEBPACK_IMPORTED_MODULE_13__["AppComponent"],
            _components_auth_auth_component__WEBPACK_IMPORTED_MODULE_4__["AuthComponent"],
            _components_content_container_content_container_component__WEBPACK_IMPORTED_MODULE_5__["ContentContainerComponent"],
            _components_cutlist_browser_cutlist_browser_component__WEBPACK_IMPORTED_MODULE_6__["CutlistBrowserComponent"],
            _components_jobs_list_jobs_list_component__WEBPACK_IMPORTED_MODULE_8__["JobsListComponent"],
            _components_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_9__["PageNotFoundComponent"],
            _components_header_header_component__WEBPACK_IMPORTED_MODULE_7__["HeaderComponent"],
            _components_warning_dialog_warning_dialog_component__WEBPACK_IMPORTED_MODULE_20__["WarningDialog"],
        ],
        entryComponents: [
            _components_cutlist_browser_cutlist_browser_component__WEBPACK_IMPORTED_MODULE_6__["CutlistBrowserComponent"],
            _components_warning_dialog_warning_dialog_component__WEBPACK_IMPORTED_MODULE_20__["WarningDialog"],
        ],
        imports: [
            _app_routing_module__WEBPACK_IMPORTED_MODULE_12__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__["BrowserAnimationsModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _material_module__WEBPACK_IMPORTED_MODULE_10__["CWMaterialModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormsModule"],
            _angular_http__WEBPACK_IMPORTED_MODULE_14__["HttpModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["ReactiveFormsModule"],
        ],
        providers: [
            _services_department_service__WEBPACK_IMPORTED_MODULE_15__["DepartmentService"],
            _services_factory_job_service__WEBPACK_IMPORTED_MODULE_16__["JobService"],
            _services_localstorage_service__WEBPACK_IMPORTED_MODULE_17__["LocalStorageService"],
            _session_service__WEBPACK_IMPORTED_MODULE_19__["SessionService"],
            _services_user_service__WEBPACK_IMPORTED_MODULE_18__["UserService"],
        ],
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/app/app.component.ts":
/*!*************************************************!*\
  !*** ./src/app/components/app/app.component.ts ***!
  \*************************************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() { }
    ngOnInit() { }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: '[fps-app]',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/app/app.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.css */ "./src/app/components/app/app.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/components/app/app.css":
/*!****************************************!*\
  !*** ./src/app/components/app/app.css ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".content-container{\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\twidth: 100%;\n\tjustify-content: center;\n\talign-content: center;\n\toverflow: hidden;\n}\n\n.main-container{\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.header{\n\tflex: 1;\n\tflex-direction: row;\n\tmax-height: -webkit-min-content;\n\tmax-height: -moz-min-content;\n\tmax-height: min-content;\n\twidth: 100%;\n\tbackground-color:  #2F3D41;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9hcHAvYXBwLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLGFBQWE7Q0FDYixzQkFBc0I7Q0FDdEIsWUFBWTtDQUNaLFdBQVc7Q0FDWCx1QkFBdUI7Q0FDdkIscUJBQXFCO0NBQ3JCLGdCQUFnQjtBQUNqQjs7QUFFQTtDQUNDLGFBQWE7Q0FDYixzQkFBc0I7Q0FDdEIsWUFBWTtBQUNiOztBQUVBO0NBQ0MsT0FBTztDQUNQLG1CQUFtQjtDQUNuQiwrQkFBdUI7Q0FBdkIsNEJBQXVCO0NBQXZCLHVCQUF1QjtDQUN2QixXQUFXO0NBQ1gsMEJBQTBCO0FBQzNCIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9hcHAvYXBwLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250ZW50LWNvbnRhaW5lcntcblx0ZGlzcGxheTogZmxleDtcblx0ZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblx0aGVpZ2h0OiAxMDAlO1xuXHR3aWR0aDogMTAwJTtcblx0anVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cdGFsaWduLWNvbnRlbnQ6IGNlbnRlcjtcblx0b3ZlcmZsb3c6IGhpZGRlbjtcbn1cblxuLm1haW4tY29udGFpbmVye1xuXHRkaXNwbGF5OiBmbGV4O1xuXHRmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuXHRoZWlnaHQ6IDEwMCU7XG59XG5cbi5oZWFkZXJ7XG5cdGZsZXg6IDE7XG5cdGZsZXgtZGlyZWN0aW9uOiByb3c7XG5cdG1heC1oZWlnaHQ6IG1pbi1jb250ZW50O1xuXHR3aWR0aDogMTAwJTtcblx0YmFja2dyb3VuZC1jb2xvcjogICMyRjNENDE7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/components/auth/auth.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/auth/auth.component.ts ***!
  \***************************************************/
/*! exports provided: AuthComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthComponent", function() { return AuthComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/services/user.service */ "./src/app/services/user.service.ts");






let AuthComponent = class AuthComponent {
    constructor(router, userService, snackBar, fb) {
        this.router = router;
        this.userService = userService;
        this.snackBar = snackBar;
        this.fb = fb;
        this.formErrors = false;
        this.loginFailed = false;
        this.showProgressBar = false;
        this.loginForm = this.fb.group({
            password: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            username: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
        });
    }
    validateUser() {
        let form = this.loginForm.value;
        let username = form.username;
        let password = form.password;
        if (!(username && password)) {
            this.formErrors = true;
            return;
        }
        this.loginFailed = false;
        this.formErrors = false;
        this.showProgressBar = true;
        this.login(username, password);
    }
    login(username, password) {
        this.loginFailed = false;
        this.userService.login(username, password).subscribe((userResponse) => {
            this.handleLoginSuccess(userResponse);
        }, error => {
            console.log(error);
            this.loginFailed = true;
            this.showProgressBar = false;
        });
    }
    handleLoginSuccess(response) {
        this.showProgressBar = false;
        this.user = response;
        if (this.user.groups.factory_floor) {
            this.router.navigate(['workflows']);
        }
        else {
            this.openSnackBar("You are not authorized.");
        }
    }
    openSnackBar(message, action = '') {
        this.snackBar.open(message, action, {
            // make the snackbar stay open longer for longer messages
            duration: message.length * 70,
        });
    }
};
AuthComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: src_app_services_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] }
];
AuthComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'auth',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./auth.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/auth/auth.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./auth.css */ "./src/app/components/auth/auth.css")).default]
    })
], AuthComponent);



/***/ }),

/***/ "./src/app/components/auth/auth.css":
/*!******************************************!*\
  !*** ./src/app/components/auth/auth.css ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n.submit-button {\n\twidth: 100%;\n\tbackground-color: #2F3D41;\n\tcolor: white;\n\tfont-size: 1.25em;\n\tpadding-top: 4px;\n\tpadding-bottom: 4px;\n}\n\n.submit-button:hover {\n\tbackground-color: #415259;\n\tborder-color: #2F3D40;\n}\n\n.form-signin {\n\tmax-width: 600px;\n\tbackground-color: whitesmoke;\n\tpadding: 15px;\n\tmargin: 0 auto;\n}\n\n.form-signin .form-control {\n\tposition: relative;\n\theight: auto;\nbox-sizing: border-box;\n\tpadding: 10px;\n\tfont-size: 16px;\n}\n\n.form-signin .form-control:focus {\n\tz-index: 2;\n}\n\n.form-signin input[type=\"username\"] {\n\tmargin-bottom: -1px;\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.form-signin input[type=\"password\"] {\n\tmargin-bottom: 10px;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.card-1 {\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\ttransition: all 0.3s cubic-bezier(.25,.8,.25,1);\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/content-container/content-container.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/components/content-container/content-container.component.ts ***!
  \*****************************************************************************/
/*! exports provided: ContentContainerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentContainerComponent", function() { return ContentContainerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ContentContainerComponent = class ContentContainerComponent {
};
ContentContainerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'content-container',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./content-container.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/content-container/content-container.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./content-container.css */ "./src/app/components/content-container/content-container.css")).default]
    })
], ContentContainerComponent);



/***/ }),

/***/ "./src/app/components/content-container/content-container.css":
/*!********************************************************************!*\
  !*** ./src/app/components/content-container/content-container.css ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".content-container{\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tjustify-content: center;\n}\n\n\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9jb250ZW50LWNvbnRhaW5lci9jb250ZW50LWNvbnRhaW5lci5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Q0FDQyxhQUFhO0NBQ2Isc0JBQXNCO0NBQ3RCLE9BQU87Q0FDUCx1QkFBdUI7QUFDeEIiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL2NvbnRlbnQtY29udGFpbmVyL2NvbnRlbnQtY29udGFpbmVyLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250ZW50LWNvbnRhaW5lcntcblx0ZGlzcGxheTogZmxleDtcblx0ZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblx0ZmxleDogMTtcblx0anVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG59XG5cblxuIl19 */");

/***/ }),

/***/ "./src/app/components/cutlist-browser/cutlist-browser.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/cutlist-browser/cutlist-browser.component.ts ***!
  \*************************************************************************/
/*! exports provided: CutlistBrowserComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CutlistBrowserComponent", function() { return CutlistBrowserComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");



let CutlistBrowserComponent = class CutlistBrowserComponent {
    constructor(data) {
        this.data = data;
        this.job = data.job;
        this.image_url = this.job.attachments[0].file__url;
    }
};
CutlistBrowserComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
CutlistBrowserComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'cutlist-browser',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./cutlist-browser.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/cutlist-browser/cutlist-browser.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./cutlist-browser.css */ "./src/app/components/cutlist-browser/cutlist-browser.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], CutlistBrowserComponent);



/***/ }),

/***/ "./src/app/components/cutlist-browser/cutlist-browser.css":
/*!****************************************************************!*\
  !*** ./src/app/components/cutlist-browser/cutlist-browser.css ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".browser-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.browser-title {\n\tflex: 1;\n}\n\n.browser-content {\n\tflex: 5;\n}\n\n.browser-actions {\n\tflex: 1;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9jdXRsaXN0LWJyb3dzZXIvY3V0bGlzdC1icm93c2VyLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLGFBQWE7Q0FDYixzQkFBc0I7Q0FDdEIsWUFBWTtBQUNiOztBQUVBO0NBQ0MsT0FBTztBQUNSOztBQUVBO0NBQ0MsT0FBTztBQUNSOztBQUVBO0NBQ0MsT0FBTztBQUNSIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9jdXRsaXN0LWJyb3dzZXIvY3V0bGlzdC1icm93c2VyLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5icm93c2VyLXdyYXBwZXIge1xuXHRkaXNwbGF5OiBmbGV4O1xuXHRmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuXHRoZWlnaHQ6IDEwMCU7XG59XG5cbi5icm93c2VyLXRpdGxlIHtcblx0ZmxleDogMTtcbn1cblxuLmJyb3dzZXItY29udGVudCB7XG5cdGZsZXg6IDU7XG59XG5cbi5icm93c2VyLWFjdGlvbnMge1xuXHRmbGV4OiAxO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/components/header/header.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/components/header/header.component.ts ***!
  \*******************************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../config */ "./src/app/config.ts");
/* harmony import */ var _services_department_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/department.service */ "./src/app/services/department.service.ts");
/* harmony import */ var src_app_services_factory_job_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/factory_job.service */ "./src/app/services/factory_job.service.ts");
/* harmony import */ var src_app_session_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/session.service */ "./src/app/session.service.ts");






let HeaderComponent = class HeaderComponent {
    constructor(departmentService, jobService, sessionService) {
        this.departmentService = departmentService;
        this.jobService = jobService;
        this.sessionService = sessionService;
        this.refreshing = false;
        this.filterViewTypes = ['SERVICE/SAMPLES', 'JOBS'];
        this.departments = [];
        /** temp value for setting session value */
        this.filterViewType = null;
        /** temp value for setting session value */
        this.department = null;
        this.filterViewType = this.filterViewTypes[0];
        this.setViewType();
    }
    ngOnInit() {
        this.departmentService.loadDepartments().subscribe((departments) => {
            this.departments = departments;
            this.sessionService.selectedDepartment.subscribe((d) => {
                this.department = d;
            });
            // auto select first
            if ((departments || {}).length) {
                this.sessionService.selectedDepartment.next(this.departments[0]);
            }
        });
        this.sessionService.selectedFilterViewType.subscribe((s) => {
            console.log("filterViewType changed in session");
            this.filterViewType = s;
        });
    }
    setViewType() {
        this.sessionService.selectedFilterViewType.next(this.filterViewType);
    }
    setDepartment() {
        this.sessionService.selectedDepartment.next(this.department);
    }
    showStagingIndicator() {
        let apiIsProduction = (_config__WEBPACK_IMPORTED_MODULE_2__["API_ROOT"] || "").indexOf('//api.cottonwoodcabinets.com') == -1;
        return apiIsProduction && !_config__WEBPACK_IMPORTED_MODULE_2__["HIDE_STAGING_INDICATOR"];
    }
    logout() {
        this.sessionService.logout();
    }
    refresh() {
        this.refreshing = true;
        this.sessionService.runRefreshAction(this.onRefreshCompleted.bind(this));
    }
    onRefreshCompleted() {
        this.refreshing = false;
    }
};
HeaderComponent.ctorParameters = () => [
    { type: _services_department_service__WEBPACK_IMPORTED_MODULE_3__["DepartmentService"] },
    { type: src_app_services_factory_job_service__WEBPACK_IMPORTED_MODULE_4__["JobService"] },
    { type: src_app_session_service__WEBPACK_IMPORTED_MODULE_5__["SessionService"] }
];
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/header/header.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.css */ "./src/app/components/header/header.css")).default]
    })
], HeaderComponent);



/***/ }),

/***/ "./src/app/components/header/header.css":
/*!**********************************************!*\
  !*** ./src/app/components/header/header.css ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".header {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding: 3px;\n}\n\n.title {\n\tmargin:         0;\n\tpadding:        0;\n\ttext-align:     center;\n\tdisplay:        inline;\n\n\tfont-family:    'Serif';\n\tletter-spacing: 8px;\n\tfont-weight:    600;\n\tcolor:          whitesmoke;\n}\n\nul {\n\tpadding: 0px;\n\tmargin: -5px 0 -15px 0;\n\tlist-style: none;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\nul > li {\n\tpadding:        0px;\n\tmargin:         0px;\n\t/* line-height:    50px; */\n\tpadding-left:   3em;\n\tdisplay: inline-block;\n\n\tfont-size:      14px;\n\tletter-spacing: 2px;\n\tfont-weight:    600;\n\tcolor:          #9BAFB6;\n\tcursor:         pointer;\n}\n\n.mat-form-field-type-mat-select {\n\tmargin-top: 20px;\n}\n\n.mat-option {\n\tfont-size:      14px;\n\tletter-spacing: 2px;\n\tfont-weight:    600;\n}\n\n.active{\n\tbackground-color:#1E282A !important;\n\tborder:none !important;\n}\n\n.refresh-icon {\n\tfont-size:     3em;\n\tpadding-right: 10px;\n\tmargin-top:    0;\n\tmargin-left:   -2px;\n}\n\n.header-bar {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.staging-banner {\n\tposition: fixed;\n\tfont-weight: bold;\n\tz-index: 10000;\n\tmargin-top: -0.25em;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/jobs-list/jobs-list.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/jobs-list/jobs-list.component.ts ***!
  \*************************************************************/
/*! exports provided: JobsListComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobsListComponent", function() { return JobsListComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var src_app_services_department_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/department.service */ "./src/app/services/department.service.ts");
/* harmony import */ var src_app_services_factory_job_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/factory_job.service */ "./src/app/services/factory_job.service.ts");
/* harmony import */ var _cutlist_browser_cutlist_browser_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../cutlist-browser/cutlist-browser.component */ "./src/app/components/cutlist-browser/cutlist-browser.component.ts");
/* harmony import */ var src_app_session_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/session.service */ "./src/app/session.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../config */ "./src/app/config.ts");
/* harmony import */ var _warning_dialog_warning_dialog_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../warning-dialog/warning-dialog.component */ "./src/app/components/warning-dialog/warning-dialog.component.ts");










let JobsListComponent = class JobsListComponent {
    constructor(departmentService, dialog, jobService, sessionService) {
        this.departmentService = departmentService;
        this.dialog = dialog;
        this.jobService = jobService;
        this.sessionService = sessionService;
        this.jobs = [];
        this.departments = [];
        this.loading = true;
        this.dataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatTableDataSource"]();
        this.displayedColumns = [];
        this.allowDebug = _config__WEBPACK_IMPORTED_MODULE_8__["ALLOW_DEBUG"];
        this.refreshWarningTimer = null;
        this.showWarningRefreshMessageWaitTime = _config__WEBPACK_IMPORTED_MODULE_8__["JOBS_REFRESH_TIMER_DURATION"];
        /** temp value for reading session value */
        this.department = null;
        /** temp value for reading session value */
        this.filterViewType = null;
        this.loadJobsParams = {
            today: true
        };
        this.firstColumns = [
            'priority',
            'part#',
            'project-name',
            'description',
            'ship-date',
            'price',
            'unit-count',
        ];
        this.checkColumns = [
            'PURCHASING',
            'SAW/CNC',
            'EDGE BANDING',
            'DRAWERS',
            'DOORS',
            'SPECIALTY',
            'METAL',
            'ASSEMBLY',
            'STAGING',
            'FINISH',
            'HANGING',
            'SHIPPING',
            'INSTALL',
            'BILLING',
        ];
        this.lastColumns = [
            'designer',
            'customer-service',
            'engineer',
            'confirmed-date',
            'engineered-date',
            'exterior-material',
            'texture',
            'finish',
            'finish-options',
            'sheen',
            'door-frame',
            'shallow-drawer',
            'drawer-box',
            'cabinet-interior',
            'cabinet-type',
        ];
    }
    ngOnInit() {
        Object(rxjs__WEBPACK_IMPORTED_MODULE_7__["forkJoin"])(this.loadJobs(), this.departmentService.loadDepartments()).subscribe(([jobs, departments]) => {
            this.jobs = this.sortJobs(jobs);
            this.departments = departments;
            this.resolveColumns();
            this.sessionService.selectedDepartment.subscribe(this.onDepartmentChange.bind(this));
            this.sessionService.selectedFilterViewType.subscribe(this.onFilterViewTypeChange.bind(this));
            this.loading = false;
        });
        this.sessionService.setRefreshAction(this.refresh.bind(this));
        this.setWarningRefreshTimer();
    }
    sortJobs(jobs) {
        let priorityToInt = (priority) => {
            let p = 0;
            if (priority == 'normal')
                p = 1;
            if (priority == 'rush')
                p = 2;
            return p;
        };
        let sorted_by_priority = jobs.sort((a, b) => {
            let _a = priorityToInt(a.priority);
            let _b = priorityToInt(b.priority);
            return _b - _a;
        });
        // we want the higher priority values to stay bubbled up to the top, we need to strip off the time parts of these dates.
        let sorted_by_date = sorted_by_priority.sort((a, b) => {
            // will sort dates in ascending order
            let _a = a.est_delivery_date;
            let _b = b.est_delivery_date;
            // handle nulls
            if (!_a && !_b)
                return 0;
            if (!_a && _b)
                return -1;
            if (_a && !_b)
                return 1;
            // not using string padStart because it isn't supported on IE11
            // all of this is to pad the month and day so we can more accurately see which is first
            let a_values = { date: new Date(_a) };
            let b_values = { date: new Date(_b) };
            for (let x of [a_values, b_values]) {
                let year = x.date.getFullYear().toString();
                let month = (x.date.getMonth() + 1).toString();
                let day = x.date.getDate().toString();
                if (month.length == 1) {
                    month = '0' + month;
                }
                if (day.length == 1) {
                    day = '0' + day;
                }
                x['date_only'] = year + month + day;
            }
            if (a_values['date_only'] < b_values['date_only'])
                return -1;
            if (a_values['date_only'] > b_values['date_only'])
                return 1;
            return 0;
        });
        return sorted_by_date;
    }
    setWarningRefreshTimer() {
        if (this.setWarningRefreshTimer != null) {
            try {
                clearInterval(this.refreshWarningTimer);
            }
            catch (e) {
                console.warn("Could not clear the refresh warning timer.");
            }
        }
        this.refreshWarningTimer = setTimeout(this.showWarningRefreshMessage.bind(this), this.showWarningRefreshMessageWaitTime);
    }
    showWarningRefreshMessage() {
        console.log("showWarningRefreshMessage()");
        let dialogRef = this.dialog.open(_warning_dialog_warning_dialog_component__WEBPACK_IMPORTED_MODULE_9__["WarningDialog"], {
            data: {
                title: 'Warning',
                message: 'It has been a while since your last refresh, please refresh the list to make sure you have the latest info!',
                buttonText: 'OK'
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.refresh(this.setWarningRefreshTimer.bind(this));
        });
    }
    refresh(onComplete) {
        this.setWarningRefreshTimer();
        this.loadJobs().subscribe((jobs) => {
            this.jobs = this.sortJobs(jobs);
            this.rebuild();
            onComplete();
        });
    }
    onDepartmentChange(d) {
        // No department set in session
        if (!d)
            return;
        this.department = d;
        this.rebuild();
    }
    onFilterViewTypeChange(s) {
        this.filterViewType = s;
        this.rebuild();
    }
    loadJobs() {
        return this.jobService.loadJobs(this.loadJobsParams);
    }
    rebuild() {
        let partType = null;
        switch (this.filterViewType) {
            case 'JOBS':
                partType = 'JobPart';
                break;
            case 'SERVICE/SAMPLES':
                partType = 'S/ST';
                break;
            default:
                partType = 'JobPart';
                break;
        }
        // implement active
        let filteredJobs = (this.jobs || []).filter((job) => job.part_type == partType) || [];
        // No department set
        if (!this.department) {
            return;
        }
        if (this.department.slug !== 'admin') {
            filteredJobs = filteredJobs.filter(job => {
                // return if the workflow for the selected department is "today" worthy
                let wf = job.factory_workflows.find(w => w.department == this.department.id);
                if (wf.complete == null)
                    return true;
                const today = new Date();
                let completed_as_int = Date.parse(wf.complete);
                let c = new Date(completed_as_int);
                let wf_is_today = (c.getDate() == today.getDate() &&
                    c.getMonth() == today.getMonth() &&
                    c.getDay() == today.getDay());
                return wf_is_today;
            });
        }
        this.dataSource.data = filteredJobs;
        this.resolveColumns();
    }
    resolveColumns() {
        let d = this.department;
        // No department set in session, cannot resolveColumns()
        if (!d)
            return;
        if (this.sessionService.selectedFilterViewType.getValue() == 'SERVICE/SAMPLES' && this.firstColumns.indexOf('ups-tracking-number') == -1) {
            this.firstColumns.splice(5, 0, 'ups-tracking-number');
        }
        else if (this.sessionService.selectedFilterViewType.getValue() == 'JOBS' && this.firstColumns.indexOf('ups-tracking-number') > -1) {
            this.firstColumns = this.firstColumns.filter(function (e) {
                return e !== 'ups-tracking-number';
            });
        }
        this.displayedColumns = this.firstColumns.concat((d.name == 'ADMIN')
            ? this.checkColumns
            : [d.name.toUpperCase()], this.lastColumns);
        // console.log('DisplayedColumns', this.displayedColumns);
    }
    getWorkflow(job, slug) {
        let department = this.department.name == "ADMIN"
            ? (this.departments.find(d => d.slug == slug) || null)
            : this.department;
        let fw = job.getWorkflow(department.id);
        if (fw === null) {
            console.warn("Could not find workflow for slug: " + slug);
        }
        return fw;
    }
    toggleWorkflow(workflow) {
        workflow.complete = workflow.complete === null
            ? new Date().toISOString()
            : null;
        this.jobService.patchWorkflow(workflow).subscribe((result) => {
            console.log(result);
        });
    }
    updateJob(job) {
        this.jobService.patchJob(job).subscribe((result) => {
            console.log(result);
        });
    }
    openCutlistBrowser(job) {
        const dialogRef = this.dialog.open(_cutlist_browser_cutlist_browser_component__WEBPACK_IMPORTED_MODULE_5__["CutlistBrowserComponent"], {
            data: {
                job
            },
            panelClass: 'large-dialog-panel'
        });
    }
    ngOnDestroy() {
        this.sessionService.setRefreshAction(null);
    }
    debug() {
        // helpful things to look at
        // this.sessionService.selectedDepartment.getValue()
        // this.sessionService.selectedFilterViewType.getValue()
        debugger;
    }
};
JobsListComponent.ctorParameters = () => [
    { type: src_app_services_department_service__WEBPACK_IMPORTED_MODULE_3__["DepartmentService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] },
    { type: src_app_services_factory_job_service__WEBPACK_IMPORTED_MODULE_4__["JobService"] },
    { type: src_app_session_service__WEBPACK_IMPORTED_MODULE_6__["SessionService"] }
];
JobsListComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'jobs-list',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./jobs-list.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/jobs-list/jobs-list.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./jobs-list.css */ "./src/app/components/jobs-list/jobs-list.css")).default]
    })
], JobsListComponent);



/***/ }),

/***/ "./src/app/components/jobs-list/jobs-list.css":
/*!****************************************************!*\
  !*** ./src/app/components/jobs-list/jobs-list.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n\tpadding: 0px;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: scroll;\n}\n\n.loading {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.forced-width-column {\n\tmin-width: 220px;\n\tmax-width: 220px;\n}\n\n.priority-level {\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 50%;\n\tborder: 1px solid white;\n\tbox-shadow: 1px 1px 2px;\n}\n\n.priority-rush {\n\tbackground: #ff0000 !important;\n}\n\n.priority-normal {\n\tbackground: #00FF00 !important;\n}\n\ntd.mat-column-star {\n\tpadding-right: 8px;\n}\n\nth.mat-column-position, td.mat-column-position {\n\tpadding-left: 8px;\n}\n\n.mat-row:nth-child(even){\n\tbackground-color: #eee;\n}\n\n.mat-header-row {\n\tbackground-color: #2F3D41;\n\theight: 25px;\n}\n\n.mat-cell {\n\tborder-spacing: 0;\n\tjustify-content: center;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tpadding: 10px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.mat-header-cell {\n\theight: 20px;\n\tpadding: 10px;\n\tfont-size: 14px;\n\tletter-spacing: 2px;\n\tfont-weight: 600;\n\tcolor: #eee;\n\twhite-space: nowrap;\n\ttext-align: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/page-not-found/page-not-found.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/page-not-found/page-not-found.component.ts ***!
  \***********************************************************************/
/*! exports provided: PageNotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageNotFoundComponent", function() { return PageNotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let PageNotFoundComponent = class PageNotFoundComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
    }
    getUrl() {
        return this.router.url;
    }
};
PageNotFoundComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
PageNotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        providers: [],
        selector: 'page-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./page-not-found.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/page-not-found/page-not-found.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./page-not-found.css */ "./src/app/components/page-not-found/page-not-found.css")).default]
    })
], PageNotFoundComponent);



/***/ }),

/***/ "./src/app/components/page-not-found/page-not-found.css":
/*!**************************************************************!*\
  !*** ./src/app/components/page-not-found/page-not-found.css ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".flex-center-both {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n}\n\n.container {\n\twidth: 50%;\n\tmin-width: 500px;\n\tmargin-bottom:100px;\n}\n\nhr {\n    border-top: 1px solid #bdbdbd;\n    border-bottom: none;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9wYWdlLW5vdC1mb3VuZC9wYWdlLW5vdC1mb3VuZC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Q0FDQyxhQUFhO0NBQ2Isc0JBQXNCO0NBQ3RCLHVCQUF1QjtDQUN2QixZQUFZO0FBQ2I7O0FBRUE7Q0FDQyxVQUFVO0NBQ1YsZ0JBQWdCO0NBQ2hCLG1CQUFtQjtBQUNwQjs7QUFFQTtJQUNJLDZCQUE2QjtJQUM3QixtQkFBbUI7QUFDdkIiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3BhZ2Utbm90LWZvdW5kL3BhZ2Utbm90LWZvdW5kLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5mbGV4LWNlbnRlci1ib3RoIHtcblx0ZGlzcGxheTogZmxleDtcblx0ZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblx0anVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cdGhlaWdodDogMTAwJTtcbn1cblxuLmNvbnRhaW5lciB7XG5cdHdpZHRoOiA1MCU7XG5cdG1pbi13aWR0aDogNTAwcHg7XG5cdG1hcmdpbi1ib3R0b206MTAwcHg7XG59XG5cbmhyIHtcbiAgICBib3JkZXItdG9wOiAxcHggc29saWQgI2JkYmRiZDtcbiAgICBib3JkZXItYm90dG9tOiBub25lO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/components/warning-dialog/warning-dialog.component.css":
/*!************************************************************************!*\
  !*** ./src/app/components/warning-dialog/warning-dialog.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvd2FybmluZy1kaWFsb2cvd2FybmluZy1kaWFsb2cuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/warning-dialog/warning-dialog.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/warning-dialog/warning-dialog.component.ts ***!
  \***********************************************************************/
/*! exports provided: WarningDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WarningDialog", function() { return WarningDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");



let WarningDialog = class WarningDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = 'Warning';
        this.message = null;
        this.buttonText = 'OK';
        data = data || {};
        if (data.title)
            this.title = data.title;
        if (data.message)
            this.message = data.message;
        if (data.buttonText)
            this.buttonText = data.buttonText;
    }
    ngOnInit() {
    }
};
WarningDialog.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
WarningDialog = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-warning-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./warning-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/warning-dialog/warning-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./warning-dialog.component.css */ "./src/app/components/warning-dialog/warning-dialog.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], WarningDialog);



/***/ }),

/***/ "./src/app/config.ts":
/*!***************************!*\
  !*** ./src/app/config.ts ***!
  \***************************/
/*! exports provided: API_ROOT, HIDE_STAGING_INDICATOR, ALLOW_DEBUG, JOBS_REFRESH_TIMER_DURATION */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIDE_STAGING_INDICATOR", function() { return HIDE_STAGING_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALLOW_DEBUG", function() { return ALLOW_DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JOBS_REFRESH_TIMER_DURATION", function() { return JOBS_REFRESH_TIMER_DURATION; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

// TODO: We should be using the environment files and build to an environment.
// for an example look at the FR project's admin angular app.
const API_ROOT = 'https://staging-api.cottonwoodcabinets.com';
const HIDE_STAGING_INDICATOR = false;
/** Shows some debug buttons throughout the app */
const ALLOW_DEBUG = false;
/** 5 hours */
const JOBS_REFRESH_TIMER_DURATION = 1000 * 60 * 60 * 5;


/***/ }),

/***/ "./src/app/material.module.ts":
/*!************************************!*\
  !*** ./src/app/material.module.ts ***!
  \************************************/
/*! exports provided: CWMaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CWMaterialModule", function() { return CWMaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");



let CWMaterialModule = class CWMaterialModule {
};
CWMaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        exports: [
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatOptionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSelectModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSnackBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatProgressSpinnerModule"],
        ]
    })
], CWMaterialModule);



/***/ }),

/***/ "./src/app/models/Attachment.ts":
/*!**************************************!*\
  !*** ./src/app/models/Attachment.ts ***!
  \**************************************/
/*! exports provided: Attachment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Attachment", function() { return Attachment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Attachment {
    constructor() {
        this.id = 0;
        this.file__url = '';
        this.file__id = 0;
        this.uuid = '';
        this.description = '';
    }
}


/***/ }),

/***/ "./src/app/models/Department.ts":
/*!**************************************!*\
  !*** ./src/app/models/Department.ts ***!
  \**************************************/
/*! exports provided: Department */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Department", function() { return Department; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Department {
}


/***/ }),

/***/ "./src/app/models/FactoryWorkflow.ts":
/*!*******************************************!*\
  !*** ./src/app/models/FactoryWorkflow.ts ***!
  \*******************************************/
/*! exports provided: FactoryWorkflow */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FactoryWorkflow", function() { return FactoryWorkflow; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class FactoryWorkflow {
    constructor() { }
}


/***/ }),

/***/ "./src/app/models/Job.ts":
/*!*******************************!*\
  !*** ./src/app/models/Job.ts ***!
  \*******************************/
/*! exports provided: Job */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Job", function() { return Job; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Job {
    constructor() {
        this.id = 0;
        this.job_id = 0;
        this.active = true;
        this.part_no = 0;
        this.part_type = 'JobPart';
        this.project_name = 'Project Name';
        this.description = 'New Job Part';
        this.billable_cost = 0.0;
        this.unit_count = 0;
        this.est_delivery_date = '10/12/2019';
        this.ups_tracking_number = '';
        this.designer = 'designer name';
        this.customer_service_rep = 'cs name';
        this.engineer = 'engineering name';
        this.confirmed_date = '10/01/2019';
        this.engineered_date = '10/03/2019';
        this.exterior_material = 'Exterior Material';
        this.texture = 'A Texture';
        this.finish = 'A Finish';
        this.finish_options = ['Finish Options'];
        this.sheen = 'A Sheen';
        this.door = 'A Door Frame';
        this.shallow_drawer = 'A Shallow Drawer';
        this.drawer_box = 'Drawer Box Details';
        this.interior = 'Cabinet interior details';
        this.cabinet_type = 'Cabinet Type';
        this.attachments = [];
        this.factory_workflows = [];
    }
    getWorkflow(departmentId) {
        let fw = this.factory_workflows.find(fw => fw.department == departmentId) || null;
        if (fw === null) {
            console.warn("Could not find workflow for departmentId: " + departmentId);
        }
        return fw;
    }
}


/***/ }),

/***/ "./src/app/models/User.ts":
/*!********************************!*\
  !*** ./src/app/models/User.ts ***!
  \********************************/
/*! exports provided: User */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class User {
    constructor() {
        this.groups = {};
    }
}


/***/ }),

/***/ "./src/app/services/department.service.ts":
/*!************************************************!*\
  !*** ./src/app/services/department.service.ts ***!
  \************************************************/
/*! exports provided: DepartmentService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DepartmentService", function() { return DepartmentService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/http */ "./node_modules/@angular/http/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _models_Department__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../models/Department */ "./src/app/models/Department.ts");
/* harmony import */ var _session_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../session.service */ "./src/app/session.service.ts");
/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./http.service */ "./src/app/services/http.service.ts");
/* harmony import */ var _localstorage_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./localstorage.service */ "./src/app/services/localstorage.service.ts");








let DepartmentService = class DepartmentService extends _http_service__WEBPACK_IMPORTED_MODULE_6__["HttpService"] {
    constructor(http, localStorageService, sessionService) {
        super(http, localStorageService, sessionService);
        this.http = http;
        this.localStorageService = localStorageService;
        this.sessionService = sessionService;
    }
    loadDepartments() {
        return this._get(['web', 'departments'])
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((response) => {
            let departments = response.body;
            departments = (departments || []).map(d => Object.setPrototypeOf(d, _models_Department__WEBPACK_IMPORTED_MODULE_4__["Department"].prototype));
            return departments;
        }));
    }
};
DepartmentService.ctorParameters = () => [
    { type: _angular_http__WEBPACK_IMPORTED_MODULE_2__["Http"] },
    { type: _localstorage_service__WEBPACK_IMPORTED_MODULE_7__["LocalStorageService"] },
    { type: _session_service__WEBPACK_IMPORTED_MODULE_5__["SessionService"] }
];
DepartmentService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], DepartmentService);



/***/ }),

/***/ "./src/app/services/factory_job.service.ts":
/*!*************************************************!*\
  !*** ./src/app/services/factory_job.service.ts ***!
  \*************************************************/
/*! exports provided: JobService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobService", function() { return JobService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/http */ "./node_modules/@angular/http/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _models_Attachment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../models/Attachment */ "./src/app/models/Attachment.ts");
/* harmony import */ var _models_FactoryWorkflow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../models/FactoryWorkflow */ "./src/app/models/FactoryWorkflow.ts");
/* harmony import */ var _models_Job__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../models/Job */ "./src/app/models/Job.ts");
/* harmony import */ var _session_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../session.service */ "./src/app/session.service.ts");
/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./http.service */ "./src/app/services/http.service.ts");
/* harmony import */ var _localstorage_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./localstorage.service */ "./src/app/services/localstorage.service.ts");










let JobService = class JobService extends _http_service__WEBPACK_IMPORTED_MODULE_8__["HttpService"] {
    constructor(http, localStorageService, sessionService) {
        super(http, localStorageService, sessionService);
        this.http = http;
        this.localStorageService = localStorageService;
        this.sessionService = sessionService;
    }
    getJob(id) {
        return this._get(['factory_jobs', id])
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((rsp) => {
            let job = rsp.body.job;
            return Object.setPrototypeOf(job, _models_Job__WEBPACK_IMPORTED_MODULE_6__["Job"].prototype);
        }));
    }
    loadJobs(params) {
        return this._get(['web', 'factory_jobs'], params)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((response) => {
            let jobs = [];
            jobs = (response.body || []).map(j => Object.setPrototypeOf(j, _models_Job__WEBPACK_IMPORTED_MODULE_6__["Job"].prototype));
            for (let job of jobs) {
                if (job.factory_workflows === undefined) {
                    console.warn("`<Job " + job.id + ">.factory_workflows` is undefined, set to []");
                    job.factory_workflows = [];
                }
                if (job.factory_workflows.length) {
                    job.factory_workflows = job.factory_workflows
                        .map(fw => Object.setPrototypeOf(fw, _models_FactoryWorkflow__WEBPACK_IMPORTED_MODULE_5__["FactoryWorkflow"].prototype));
                }
                if (job.attachments === undefined) {
                    console.warn("`<Job " + job.id + ">.attachments` is undefined, set to []");
                    job.attachments = [];
                }
                if (job.attachments.length) {
                    job.attachments = job.attachments
                        .map(a => Object.setPrototypeOf(a, _models_Attachment__WEBPACK_IMPORTED_MODULE_4__["Attachment"].prototype));
                }
            }
            return jobs;
        }));
    }
    patchJob(job) {
        return this._patch(['web', 'jobs', job.job_id], {
            'ups_tracking_number': job.ups_tracking_number
        });
    }
    patchWorkflow(workflow) {
        return this._patch(['web', 'factory_workflows', workflow.id], workflow).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((response) => {
            return Object.setPrototypeOf(response.body, _models_FactoryWorkflow__WEBPACK_IMPORTED_MODULE_5__["FactoryWorkflow"].prototype);
        }));
    }
};
JobService.ctorParameters = () => [
    { type: _angular_http__WEBPACK_IMPORTED_MODULE_2__["Http"] },
    { type: _localstorage_service__WEBPACK_IMPORTED_MODULE_9__["LocalStorageService"] },
    { type: _session_service__WEBPACK_IMPORTED_MODULE_7__["SessionService"] }
];
JobService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], JobService);



/***/ }),

/***/ "./src/app/services/http.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/http.service.ts ***!
  \******************************************/
/*! exports provided: HttpService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpService", function() { return HttpService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/http */ "./node_modules/@angular/http/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config */ "./src/app/config.ts");




let R = /(?:\/|\.\w+)(?:\?.*)?$/;
let _check_url = (url) => {
    if (!R.test(url)) {
        console.warn(`API url without a trailing slash: ${url}`);
    }
    return url;
};
class HttpService {
    constructor(
    /** use http raw to bypass token check */
    http, localStorageService, sessionService) {
        this.http = http;
        this.localStorageService = localStorageService;
        this.sessionService = sessionService;
        this.useApiVersion = false;
        this.apiVersion = 'v1';
        /** Will be set back to null after every successful request */
        this.customErrorHandler = null;
        this.customResponseHandler = null;
    }
    apiTokenProtect() {
        if (!this.localStorageService.getApiToken()) {
            this.sessionService.logout();
            throw new Error("No token, logging out");
        }
    }
    /**
     * Wrapper for Angular's http.get().
     * Attaches headers, builds our api-url, and other conveniences that all of our requests need.
     * @param uri          will be used to build the end point path.
     * @param urlParams    will be turned into "?key=value&key=value" at the end of the uri.
     * @param directAppend Will directly append to the end of the URL, good for Q[]= or any other dynamic rest.
     *                     Don't put a ? in the string.
     */
    _get(uri, urlParams = null, options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"](), directAppend = '') {
        this.apiTokenProtect();
        if (this.useApiVersion) {
            uri = [this.apiVersion, ...uri];
        }
        let path = _check_url(this.getFullPath({ uri, params: urlParams }));
        path = this.appendDirectAppend(path, directAppend);
        if (options == null) {
            options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]();
        }
        options.headers = this.headers;
        return this.http.get(path, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(response => {
            if (this.customResponseHandler) {
                let handler = this.customResponseHandler;
                this.customResponseHandler = null;
                return handler(response);
            }
            this.customErrorHandler = null;
            return this.parseResponse(response);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])(error => {
            let handler = this.customErrorHandler ? this.customErrorHandler(error) : this.handleError(error);
            this.customErrorHandler = null;
            return handler;
        }));
    }
    /**
     * Wrapper for Angular's http.post().
     * Attaches headers, builds our api-url, and other conveniences that all of our requests need.
     * @param uri       used to build the end point path.
     * @param body      the payload, can be a <new FormData()> to mimic an html form submit.
     * @param urlParams turned into "?key=value&key=value" at the end of the uri.
     * @param options   Other options you might want to pass in, headers will be automatically added
     */
    _post(uri, body, urlParams = null, options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]()) {
        this.apiTokenProtect();
        if (this.useApiVersion) {
            uri = [this.apiVersion, ...uri];
        }
        let path = _check_url(this.getFullPath({ uri, params: urlParams }));
        if (options == null) {
            options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]();
        }
        options.headers = this.headers;
        return this.http.post(path, body, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(response => {
            if (this.customResponseHandler) {
                let handler = this.customResponseHandler;
                this.customResponseHandler = null;
                return handler(response);
            }
            this.customErrorHandler = null;
            return this.parseResponse(response);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])(error => {
            let handler = this.customErrorHandler ? this.customErrorHandler(error) : this.handleError(error);
            this.customErrorHandler = null;
            return handler;
        }));
    }
    /**
     * Wrapper for Angular's http.put().
     * Attches headers, builds our api-url, and other conveniences that all of our requests need.
     * @param uri
     * @param body
     * @param urlParams
     * @param options
     * @param directAppend
     */
    _put(uri, body, options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]()) {
        this.apiTokenProtect();
        if (this.useApiVersion) {
            uri = [this.apiVersion, ...uri];
        }
        let path = _check_url(this.getFullPath({ uri }));
        if (options == null) {
            options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]();
        }
        options.headers = this.headers;
        return this.http.put(path, body, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(response => {
            if (this.customResponseHandler) {
                let handler = this.customResponseHandler;
                this.customResponseHandler = null;
                return handler(response);
            }
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])(error => {
            let handler = this.customErrorHandler ? this.customErrorHandler(error) : this.handleError(error);
            this.customErrorHandler = null;
            return handler;
        }));
    }
    /**
     * Wrapper for Angular's http.patch().
     * Attaches headers, builds our api-url, and other conveniences that all of our requests need.
     * @param uri       used to build the end point path.
     * @param body      the payload, can be a <new FormData()> to mimic an html form submit.
     * @param urlParams turned into "?key=value&key=value" at the end of the uri.
     * @param directAppend Will directly append to the end of the URL, good for Q[]= or any other dynamic rest. Don't put a ? in the string.
     */
    _patch(uri, body, urlParams = null, options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"](), directAppend = '') {
        this.apiTokenProtect();
        if (this.useApiVersion) {
            uri = [this.apiVersion, ...uri];
        }
        let path = _check_url(this.getFullPath({ uri, params: urlParams }));
        path = this.appendDirectAppend(path, directAppend);
        if (options == null) {
            options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]();
        }
        options.headers = this.headers;
        return this.http.patch(path, body, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(response => {
            if (this.customResponseHandler) {
                let handler = this.customResponseHandler;
                this.customResponseHandler = null;
                return handler(response);
            }
            this.customErrorHandler = null;
            return this.parseResponse(response);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])(error => {
            let handler = this.customErrorHandler ? this.customErrorHandler(error) : this.handleError(error);
            this.customErrorHandler = null;
            return handler;
        }));
    }
    /**
     * Wrapper for Angular's http.delete().
     * Attaches headers, builds our api-url, and other conveniences that all of our requests need.
     * @param uri       will be used to build the end point path.
     * @param urlParams will be turned into "?key=value&key=value" at the end of the uri.
     */
    _delete(uri, urlParams = null, options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]()) {
        this.apiTokenProtect();
        if (this.useApiVersion) {
            uri = [this.apiVersion, ...uri];
        }
        let path = _check_url(this.getFullPath({ uri, params: urlParams }));
        if (options == null) {
            options = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["RequestOptions"]();
        }
        options.headers = this.headers;
        return this.http.delete(path, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(response => {
            if (this.customResponseHandler) {
                let handler = this.customResponseHandler;
                this.customResponseHandler = null;
                return handler(response);
            }
            this.customErrorHandler = null;
            return this.parseResponse(response);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])(error => {
            let handler = this.customErrorHandler ? this.customErrorHandler(error) : this.handleError(error);
            this.customErrorHandler = null;
            return handler;
        }));
    }
    parseResponse(response) {
        if (response._body) {
            response.body = JSON.parse(response._body);
        }
        response.success = false;
        if (response.status) {
            let status = response.status;
            response.success = status >= 200 && status < 300;
        }
        return response;
    }
    /**
     * Builds the full URL:
     * (path from Config) + parts.uri.join("/") + "?" + (key values in parts.params)
     */
    getFullPath(parts) {
        let path = _config__WEBPACK_IMPORTED_MODULE_3__["API_ROOT"] + '/';
        if (parts.uri) {
            path += parts.uri.map(p => p.toString()).join("/") + '/';
        }
        if (parts.params) {
            path += '?' + this.objectToParams(parts.params);
        }
        return path;
    }
    appendDirectAppend(path, directAppend) {
        if (directAppend) {
            // Append either a ? or & to our path then append the directAppend.
            // Don't put a ? in the directAppend when calling this function ^.
            path += path.indexOf("?") == -1 ? '?' : '&';
            path += directAppend;
        }
        return path;
    }
    /**
     * Converts an object to key value pairs in a string.
     * For example: obj = {name: "Mario", job: "plumber", partner: "Luigi"} =>
     * "name=Mario&job=plumber&partner=Luigi"
     */
    objectToParams(obj) {
        // to make typescript not complain
        let flat_pairs = Object.entries(obj).reduce((arr, [key, value]) => {
            if ((value || 0).length && typeof value !== typeof '') {
                // flatten array types (not strings)
                return arr.concat([].map.call((value), inner_value => `${key}=${inner_value}`));
            }
            else {
                // flatten scalars
                if (value && typeof value === typeof {}) {
                    // "[object Object]" is an error
                    console.warn("Cannot serialize object type", value);
                    throw new Error("Failed to serialize all querystring arguments");
                }
                if (typeof value === typeof void 0) {
                    // ignore undefined values
                    return arr;
                }
                return arr.concat(`${key}=${value}`);
            }
        }, []);
        let querystring = flat_pairs.join('&');
        return querystring;
    }
    handleError(error) {
        // TODO Replace with a remote logging infrastructure
        let errMsg;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.log(errMsg);
        // the _body always comes back as json, like "{"detail":"Not found."}"
        // convert it so we don't have to every time.
        error._body = JSON.parse(error._body);
        error.custom_message = errMsg;
        throw error;
    }
    get headers() {
        let h = new _angular_http__WEBPACK_IMPORTED_MODULE_1__["Headers"]();
        let auth_token = this.localStorageService.getApiToken();
        if (auth_token) {
            h.append('Authorization', 'Token ' + auth_token);
        }
        return h;
    }
}


/***/ }),

/***/ "./src/app/services/localstorage.service.ts":
/*!**************************************************!*\
  !*** ./src/app/services/localstorage.service.ts ***!
  \**************************************************/
/*! exports provided: LocalStorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStorageService", function() { return LocalStorageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LocalStorageService = class LocalStorageService {
    constructor() {
        this.localStorageKeys = {
            apiToken: 'api_token'
        };
    }
    apiTokenIsSet() {
        return this.getApiToken() != null;
    }
    getApiToken() {
        return this.getItem(this.localStorageKeys.apiToken);
    }
    setApiToken(apiKey) {
        this.setItem(this.localStorageKeys.apiToken, apiKey);
    }
    clearApiToken() {
        this.removeItem(this.localStorageKeys.apiToken);
    }
    // abstracted so we can do other things if we want to, like logging
    setItem(key, value) {
        localStorage.setItem(key, value);
    }
    // abstracted so we can do other things if we want to, like logging
    getItem(key) {
        return localStorage.getItem(key);
    }
    removeItem(key) {
        localStorage.removeItem(key);
    }
};
LocalStorageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], LocalStorageService);



/***/ }),

/***/ "./src/app/services/user.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/user.service.ts ***!
  \******************************************/
/*! exports provided: UserService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return UserService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/http */ "./node_modules/@angular/http/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _models_User__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../models/User */ "./src/app/models/User.ts");
/* harmony import */ var _session_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../session.service */ "./src/app/session.service.ts");
/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./http.service */ "./src/app/services/http.service.ts");
/* harmony import */ var _localstorage_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./localstorage.service */ "./src/app/services/localstorage.service.ts");









let UserService = class UserService extends _http_service__WEBPACK_IMPORTED_MODULE_7__["HttpService"] {
    constructor(http, localStorageService, sessionService) {
        super(http, localStorageService, sessionService);
        this.http = http;
        this.localStorageService = localStorageService;
        this.sessionService = sessionService;
    }
    login(username, password) {
        let body = {
            password,
            username,
        };
        // bypass the HTTP wrapper since it uses our API key
        let path = this.getFullPath({ uri: ['rest-auth', 'login'] });
        let headers = new _angular_http__WEBPACK_IMPORTED_MODULE_2__["Headers"]();
        return this.http.post(path, body, { headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["concatMap"])(response => {
            response = response.json();
            this.localStorageService.setApiToken(response['key']);
            return this.tokenLogin();
        }));
    }
    tokenLogin() {
        let token = this.localStorageService.getApiToken();
        return token ? this.fetchUserInfoFromToken() : Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(null);
    }
    fetchUserInfoFromToken() {
        let user = null;
        return this._get(['rest-auth', 'user'])
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            user = Object.setPrototypeOf(response.body, _models_User__WEBPACK_IMPORTED_MODULE_5__["User"].prototype);
            this.sessionService.user = user;
            // false to not force our defaults
            //user.setDefaultSettings(false);
            return user;
        }));
    }
};
UserService.ctorParameters = () => [
    { type: _angular_http__WEBPACK_IMPORTED_MODULE_2__["Http"] },
    { type: _localstorage_service__WEBPACK_IMPORTED_MODULE_8__["LocalStorageService"] },
    { type: _session_service__WEBPACK_IMPORTED_MODULE_6__["SessionService"] }
];
UserService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], UserService);



/***/ }),

/***/ "./src/app/session.service.ts":
/*!************************************!*\
  !*** ./src/app/session.service.ts ***!
  \************************************/
/*! exports provided: SessionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SessionService", function() { return SessionService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _services_localstorage_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./services/localstorage.service */ "./src/app/services/localstorage.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");





let SessionService = class SessionService {
    constructor(localStorageService, router) {
        this.localStorageService = localStorageService;
        this.router = router;
        this.user = null;
        this.selectedDepartment = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
        this.selectedFilterViewType = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
        this.refreshAction = null;
    }
    setRefreshAction(action) {
        this.refreshAction = action;
    }
    runRefreshAction(onDone) {
        try {
            this.refreshAction(onDone);
        }
        catch (e) {
            console.warn(e);
        }
    }
    logout() {
        this.user = null;
        this.localStorageService.clearApiToken();
        this.router.navigate(['']);
    }
};
SessionService.ctorParameters = () => [
    { type: _services_localstorage_service__WEBPACK_IMPORTED_MODULE_3__["LocalStorageService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
SessionService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], SessionService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /var/cw-staging/fps/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map